import React from "react";
import Notebooks from "./components/Notebooks";

function Notes() {
  return <Notebooks />;
}

export default Notes;
